import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Rules} from '../models/rules';
import {LoadRulesSuccessAction, rulesActionTypes} from '../actions/contract-rules-load';
import {rulesUpdateActionTypes, UpdateNewRulesAction} from '../actions/contract-rules-update';

export interface RulesState {
  rules: Rules[];
}

const initialState: RulesState = {
  rules: undefined
};

export function RulesReducer(state: RulesState = initialState, action: Action): RulesState {
  switch (action.type) {
    case rulesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case rulesUpdateActionTypes.UPDATE_NEW_RULES:
      return handleUpdateNewRulesAction(state, action);
    case rulesActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case rulesActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: RulesState, action: LoadRulesSuccessAction): RulesState {
  const newState: RulesState = { rules: action.payload };
  return newState;
}
function handleUpdateNewRulesAction(state: RulesState, action: UpdateNewRulesAction): RulesState {
  const newState = _.cloneDeep(state);
  if (newState.rules) {
    newState.rules.push(action.payload);
  } else {
    newState.rules = [];
    newState.rules.push(action.payload);
  }
  return newState;
}

function handleLoadClearActions(): RulesState {
  return initialState
}

function handleLoadErrorActions(state: RulesState): RulesState {
  return state;
}

export const rulesSelectors = {
  rules: (state: RulesState) => _.get(state, 'rules', null)
};


